import { render } from "./App.vue?vue&type=template&id=50833520"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AstarWorkPlus\\ChipCheck\\Chiky_cartridgeChip_client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__